module.exports = __webpack_public_path__ + "static/media/boothBg.763753df.jpg";